import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CompGridService {
	public subject: Subject<any> = new Subject();

	/**
	 * Broadcasts an event.
	 * @param event: any
	 */
	setRuleSelected(event: any): void {
		this.subject.next(event);
	}

	/**
	 * Observable for service change.
	 *
	 */
	getRuleSelected(): Observable<any> {
		return this.subject.asObservable();
	}
}
